import {EligiblePayments} from '../../../shared-gen/Payment/Rules/EligiblePayments';
import {SaniFairEligibility} from '../../../shared-gen/Payment/Rules/SaniFairEligibility';

export class EligiblePaymentsFun {

    static createDefault(): EligiblePayments {
        return {
            SaniFair: SaniFairEligibility.Allowed,
            SaniFairMinCents: 0
        }
    }

}
